//= require rails-ujs
//= require turbolinks
                                                
require("trix")
require("@rails/actiontext")
import "../stylesheets/application"